import type { YachtGameState, YachtLegalActions } from "../types";
import { selectScorePreviews } from "./score-preview";

export function selectLegalActions(
  state: YachtGameState,
  viewerPlayerId?: string,
): YachtLegalActions {
  if (!viewerPlayerId || state.phase !== "ROLLING") {
    return { canRoll: false, holdableDice: [], scoreableCategories: [] };
  }

  const slot = state.turnSlotsByPlayerId[viewerPlayerId];
  if (!slot || slot.status !== "OPEN") {
    return { canRoll: false, holdableDice: [], scoreableCategories: [] };
  }

  const canRoll =
    slot.rollCount < 3 && (slot.rollCount === 0 || !slot.held.every(Boolean));
  const canHold = slot.rollCount > 0 && slot.rollCount < 3;
  const holdableDice = canHold
    ? slot.dice
        .map((die, index) => (die === null ? -1 : index))
        .filter((index) => index >= 0)
    : [];

  return {
    canRoll,
    holdableDice,
    scoreableCategories: selectScorePreviews(state, viewerPlayerId),
  };
}
